const Props = {
  public_key: "fnADuMvMOsACE5Q_fyoARijNbftfObIrUYQ6Rx8E",
};

export default Props;
